import AsyncStorage from "@react-native-async-storage/async-storage";
import type { TokenStore } from "@axio/auth";

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

export const createRNTokenStore = (): TokenStore => {
  return {
    getAccessToken: () => AsyncStorage.getItem(ACCESS_TOKEN_KEY),
    getRefreshToken: () => AsyncStorage.getItem(REFRESH_TOKEN_KEY),
    setTokens: async ({ accessToken, refreshToken }) => {
      await AsyncStorage.multiSet([
        [REFRESH_TOKEN_KEY, refreshToken],
        [ACCESS_TOKEN_KEY, accessToken],
      ]);
    },
    setAccessToken: (accessToken: string) => AsyncStorage.setItem(ACCESS_TOKEN_KEY, accessToken),
    clearTokens: () => AsyncStorage.multiRemove([ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY]),
  };
};
